module.exports = { api: process.env.REACT_APP_SERVER_API_URL };
